import type { StyleSpecification } from 'maplibre-gl'

const E2E_MODE_QUERY_KEY = 'routecamp-e2e'

export const E2E_MAP_STYLE: StyleSpecification = {
  version: 8,
  name: 'Routecamp E2E',
  sources: {},
  layers: [
    {
      id: 'background',
      type: 'background',
      paint: {
        'background-color': '#f5f5f4',
      },
    },
  ],
}

export function isE2eMode(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    if (window.location.search.includes(E2E_MODE_QUERY_KEY)) {
      return true
    }

    return window.localStorage.getItem(E2E_MODE_QUERY_KEY) === 'true'
  } catch {
    return false
  }
}
